import { Entity } from 'src/app/core/data/schema/entity';
import { Page, PageType } from './page';
import { SafeResourceUrl } from '@angular/platform-browser';
import { ServiceHelper } from 'src/app/core/helper/services.helper';
import { AppSettings } from 'src/app/core/configs/app.settings';
import { Utilities } from 'src/app/core/helper/util';

/**
 * Feature
 */
export class Feature extends Entity{

    static className = 'Feature';
    static idField = 'featureId';
    
    featureId: number = 0;
    pageId: number;
    header: string;
    subheader: string;
    buttonLabel: string;
    sortOrder: number;
    overlayColor: string;
    fontColor: string = "#000";

    // these need to be mapped in API
    slug: string;
    pgType: PageType;
    featureImgPath: string; // should be mapped to featured if set, otherwise imagePaths
    imagePaths: string; // from page media tab images, since featureImg might be square

    // used locally only
    sanitizedImgPath: SafeResourceUrl;

    get hasButtonLbl() { return !Utilities.stringEmpty(this.buttonLabel);}
    get hasHeader() { return !Utilities.stringEmpty(this.header);}
    get hasSubHeader() { return !Utilities.stringEmpty(this.subheader);}

    constructor(f?: Partial<Feature>) {
        super();
        Object.assign(this, f);
    }

    // ----------------------------------------------------
    // Service-like features from here on down
    // ----------------------------------------------------

    // keep local cache of last accessed object, both a copy that is never modified unless saved,
    // and a 'working copy' that is edited in screens.
    // protected static _cachedServerObj: Menu; // unmodified until saved
    // protected static _cachedObj: Menu; // working copy
    // protected static _cacheExpiry: number;
    static async updateSortOrder(features: Feature[]) {
        await ServiceHelper.httpSvc.put(features, `${AppSettings.apiURL}/features/updateSort`, 'json');
    }

    static async fetchPagesWithFeatures(): Promise<Page[]>{
        return await Page.fetchArray(Page, 'features', `pagesWithFeatures`);
    }
    
}
